var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},_vm._l((_vm.elements),function(element){return _c('div',{staticClass:"element",class:_vm.componentName(element)},[_c(_vm.componentName(element),{tag:"component",attrs:{"element":element}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }